export const NEW = 'New';
